export const NEW = 'New';
